<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-alert-decagram</v-icon>{{$t('orderaction.types')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ActionTypeForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ActionTypeForm from '../../components/actiontype/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ActionType';

const { mapFields } = createHelpers({
  getterType: 'actiontype/getField',
  mutationType: 'actiontype/updateField'
});

export default {
  name: 'ActionTypeCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ActionTypeForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('actiontype', ['create', 'reset'])
  }
};
</script>
